<script lang="ts">
	import CkEditorContent from "@components/common/CkEditorContent.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";

	const {
		html,
		reversed,
		lightboxId,
		media,
		mediaClass,
	}: {
		html: string;
		reversed: boolean;
		lightboxId: string | undefined;
		media: Snippet;
		mediaClass?: ClassValue;
	} = $props();
</script>

<div
	class={[
		"flex items-center flex-col gap-10 md:gap-15 lg:gap-20 mb-4",
		reversed ? "flex-col-reverse md:flex-row-reverse" : "md:flex-row",
	]}
>
	<div class="flex-1 min-w-0">
		<CkEditorContent {html} {lightboxId} />
	</div>
	<div class={["relative min-w-0 max-w-full mx-auto md:mx-0", mediaClass]}>
		{@render media()}
	</div>
</div>
